module.exports = __webpack_public_path__ + "img/visa.2652890.svg";